var Webgl = (function(){

    function Webgl($container){
        this.time = 0;

        this.ambientColor = [ 0, 0, 0 ];

        this.usePostprocessing = true;

        this.scene = new THREE.Scene();
        this.scene.fog = new THREE.FogExp2( 0x555a5f, 0.0003 );

        this.camera = new THREE.PerspectiveCamera(50, window.innerWidth / window.innerHeight, 1, 10000);
        this.camera.position.z = 500;

        this.terrain = new Terrain();
        this.scene.add(this.terrain);

        this.renderer = new THREE.WebGLRenderer();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.setClearColor(0x555a5f);

        /*-----------------------------------------------------------------
            Objects
        -----------------------------------------------------------------*/
        this.accident = new Accident();
        this.scene.add(this.accident);
        this.accident.position.set(500, 800, -2000);

        this.cube = new Cube();
        this.scene.add(this.cube);
        this.cube.position.set(0, 1000, -2000);

        this.box = new Box();
        this.scene.add(this.box);
        this.box.position.set(-400, 800, -2000);

        this.geometries = new Geometries();
        this.scene.add(this.geometries);
        this.geometries.position.set(-1350, 800, -2000);

        this.materials = new Materials();
        this.scene.add(this.materials);
        this.materials.position.set(-950, 800, -3780);

        this.lights = new Lights();
        this.scene.add(this.lights);
        this.lights.position.set(-1000, 800, -4280);

        this.particles = new Particles();
        this.scene.add(this.particles);
        this.particles.position.set(0, 800, -4000);

        /*-----------------------------------------------------------------
            Lights
        -----------------------------------------------------------------*/
        this.light = new THREE.PointLight(0xFFFFFF, 0.6);
        this.scene.add(this.light);
        this.light.position.copy(this.cube.position);
        this.light.position.y -= 800;

        this.blueLight = new THREE.PointLight(0x3facc8);
        this.scene.add(this.blueLight);
        this.blueLight.position.set(-1200, 800, -4280);

        this.redLight = new THREE.PointLight(0xeb4357);
        this.scene.add(this.redLight);
        this.redLight.position.set(-800, 800, -4280);

        this.ambientLight = new THREE.AmbientLight(0x000000);
        this.ambientLight.color.setRGB(this.ambientColor[0] / 255, this.ambientColor[1] / 255, this.ambientColor[2] / 255);
        this.scene.add(this.ambientLight);

        this.bluePointLightHelper = new LightHelper(this.blueLight, 5);
        this.scene.add(this.bluePointLightHelper);

        this.redPointLightHelper = new LightHelper(this.redLight, 5);
        this.scene.add(this.redPointLightHelper);

        this.moveColoredLights(0);

        /*-----------------------------------------------------------------
            Timeline
        -----------------------------------------------------------------*/
        this.initPostProcessing();

        this.tl = new TimelineMax();
        this.tl.from(this.terrain.rotation, 2, {x: Math.PI * 0.4, ease: Expo.easeInOut}, 1);
        this.tl.addLabel('title', 3);

        this.tl.to(this.camera.position, 2, {z: -2000, y: 800, ease: Expo.easeInOut}, 3);
        this.tl.addLabel('experiment', 5);
        
        this.tl.to(this.camera.rotation, 1, {y: -Math.PI * 0.5, ease: Expo.easeInOut}, 5);
        this.tl.fromTo(this.accident.mesh.material, 0.5, {opacity: 0}, {opacity: 1}, 5);
        this.tl.addLabel('accident', 6);

        this.tl.to(this.accident.mesh.material, 0.5, {opacity: 0}, 6.5);
        this.tl.set(this.cube.mesh, {visible: true}, 6);
        this.tl.set(this.cube.meshFull, {visible: false}, 6);
        this.tl.fromTo(this.cube.mesh.material, 0.5, {opacity: 0}, {opacity: 1}, 6);
        this.tl.to(this.camera.rotation, 1, {y: 0, x: Math.PI * 0.5, ease: Expo.easeInOut}, 6);
        this.tl.addLabel('three', 7);

        this.tl.set(this.cube.meshFull, {visible: true}, 7.1);
        this.tl.set(this.cube.meshFull.position, {y: 0}, 7.1);
        this.tl.to(this.cube.mesh.material, 0.5, {opacity: 0}, 7.1);
        this.tl.set(this.cube.mesh, {visible: false}, 7.5);
        this.tl.fromTo(this.cube.meshFull.material, 0.5, {opacity: 0}, {opacity: 1}, 7.1);
        this.tl.addLabel('engine', 8);

        this.tl.insert(this.cube.tl, 8);
        this.tl.addLabel('math', 9);

        this.tl.to(this.camera.rotation, 1, {y: Math.PI * 0.5, x: 0, ease: Expo.easeInOut}, 9);
        this.tl.to(this.cube.meshFull.material, 0.5, {opacity: 0}, 9);
        this.tl.fromTo(this.box.mesh.material, 0.5, {opacity: 0}, {opacity: 1}, 9);
        this.tl.fromTo(this.box.contentMesh.material, 0.5, {opacity: 0}, {opacity: 1}, 9);
        this.tl.addLabel('object', 10);

        this.tl.to(this.camera.position, 1, {x: -1000, ease: Expo.easeInOut}, 10);
        this.tl.addLabel('mesh', 11);

        this.tl.insert(this.geometries.tl, 11);
        this.tl.addLabel('geometries', 12.3);

        this.tl.to(this.camera.rotation, 1, {y: 0, ease: Expo.easeInOut}, 12.3);
        this.tl.to(this.camera.position, 1, {z: -3500, ease: Expo.easeInOut}, 12.3);
        this.tl.insert(this.materials.tl, 12.9);
        this.tl.addLabel('materials', 14.7);

        this.tl.to(this.camera.position, 1, {z: -4000, ease: Expo.easeInOut}, 14.7);
        this.tl.fromTo(this.lights.material, 0.5, {opacity: 0}, {opacity: 1}, 15.2);
        this.tl.fromTo(this.blueLight, 0.5, {intensity: 0}, {intensity: 1}, 15.2);
        this.tl.fromTo(this.redLight, 0.5, {intensity: 0}, {intensity: 1}, 15.2);
        this.tl.fromTo(this.bluePointLightHelper.material, 0.5, {opacity: 0}, {opacity: 1}, 15.2);
        this.tl.fromTo(this.redPointLightHelper.material, 0.5, {opacity: 0}, {opacity: 1}, 15.2);
        this.tl.addLabel('lights', 15.7);

        this.tl.fromTo(this.lights.material, 0.5, {reflectivity: 0}, {reflectivity: 0.5}, 15.7);
        this.tl.to(this.bluePointLightHelper.material, 0.5, {opacity: 0}, 15.7);
        this.tl.to(this.redPointLightHelper.material, 0.5, {opacity: 0}, 15.7);
        this.tl.addLabel('shaders', 16.2);

        this.tl.to(this.camera.rotation, 1, {y: -Math.PI * 0.5, ease: Expo.easeInOut}, 16.2);
        this.tl.to(this.camera.position, 1, {x: 0, ease: Expo.easeInOut}, 16.2);
        this.tl.fromTo(this.particles.position, 0.1, {y: -100000}, {y: 800}, 16.2);
        this.tl.addLabel('way', 17.2);

        this.tl.tweenTo('title');

        $container.append(this.renderer.domElement);

    }

    Webgl.prototype.constructor = Webgl;

    Webgl.prototype.initPostProcessing = function() {
        this.composer = new THREE.EffectComposer(this.renderer);
        this.composer.addPass(new THREE.RenderPass(this.scene, this.camera));

        this.vignetteEffect = new THREE.ShaderPass(THREE.VignetteShader);
        this.composer.addPass(this.vignetteEffect);

        this.tiltShiftEffect = new THREE.ShaderPass(THREE.HorizontalTiltShiftShader);
        this.tiltShiftEffect.uniforms.r.value = 0.6;
        this.composer.addPass(this.tiltShiftEffect);

        this.bleachEffect = new THREE.ShaderPass(THREE.BleachBypassShader);
        this.composer.addPass(this.bleachEffect);
        this.bleachEffect.renderToScreen = true;
    };

    Webgl.prototype.resize = function() {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.composer.setSize(window.innerWidth, window.innerHeight);
    };

    Webgl.prototype.goTo = function(label) {
        this.tl.tweenTo(label);
    };

    Webgl.prototype.moveColoredLights = function(t) {
        this.blueLight.position.x = -1000 + Math.cos(t * 2) * 150;
        this.blueLight.position.z = -4280 + Math.sin(t * 2) * 75;
        this.blueLight.position.y = 800 + Math.sin(t * 2) * 75;
        this.redLight.position.x = -1000 + Math.sin(t * 2) * 150;
        this.redLight.position.z = -4280 + Math.cos(t * 2) * 75;
        this.redLight.position.y = 800 + Math.sin(t * 2) * 75;
    };

    Webgl.prototype.render = function() {
        this.time += 0.01;
        var label = this.tl.currentLabel();

        if(label === 'accident' || label === 'experiment') {
            this.accident.update();
        }
        if(label === 'accident' || label === 'three' || label === 'engine' || label === 'math') {
            this.cube.update();
        }
        if(label === 'math' || label === 'object') {
            this.box.update(this.time);
        }
        if(label === 'mesh' || label === 'geometries') {
            this.geometries.update();
        }
        if(label === 'materials' || label === 'geometries') {
            this.materials.update();
        }
        if(label === 'lights' || label === 'materials' || label === 'shaders') {
            this.moveColoredLights(this.time);
        }
        if(label === 'shaders' || label === 'way') {
            this.particles.update();
        }

        if(this.usePostprocessing) {
            this.composer.render();
        }
        else {
            this.renderer.render(this.scene, this.camera);
        }

    };

    return Webgl;
})();